import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from './types'

export const getKeywordQueryFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/keyword_query_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
addCache(getKeywordQueryFacts)

export const getKeywordQueryFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/keyword_query_facts/aggregate/banner/export/',
        params
    )
